import React from 'react';
import { createRoot } from 'react-dom/client';
import AppRouter from './app.router';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/style.css';
import './assets/css/app.css';
import './assets/css/auth.css';
import './assets/css/custom-rtl.css';
import './assets/css/dropzone.css';
import './assets/css/custom.css';
import './assets/css/style-copy.css';
// import './assets/css/style1.css';
// import './assets/css/style2.css';
// import './assets/css/style3.css';
// import './assets/css/style4.css';
// import './assets/css/style5.css';
import './assets/css/responsive.css';
import { Provider } from 'react-redux';
import store from './core/redux/store';
import '../index.css';
import ScrollToTopButton from './pages/Components/scrollToTop';
import '../node_modules/@iconscout/unicons/css/line.css';
import WhatsappIcon from './components/WhatsappIcon';
import { whatsappConfig } from './config/whatsapp';

const App = () => {
  const hostName = window.location.hostname;
  const config = whatsappConfig[hostName];

  return (
    <>
      <Provider store={store}>
        {config?.showWhatsapp && (
          <WhatsappIcon number={config.number} message={config.message} />
        )}
        <ToastContainer
          position="top-right"
          autoClose={2000}
          limit={1}
          theme="light"
          hideProgressBar={false}
        />
        <ScrollToTopButton />
        <AppRouter />
      </Provider>
    </>
  );
};
// console.log(process.env.REACT_APP_API_URL);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
